import {
    BANNERS_FETCH,
    BANNERS_ADD,
    BANNERS_EDIT,
    BANNERS_REMOVE,
    BANNERS_ERROR
} from "../store/types";

const INITIAL_STATE = {
    date: [],
    loading: false,
    error: {
        flag: false,
        msg: null
    }
};

export const bannersreducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case BANNERS_FETCH:
            return {
                ...state,
                date: action.payload,
                loading: false
            };
        case BANNERS_ADD:
            return {
                ...state,
                date: [...state.date, action.payload],
                loading: false
            };
        case BANNERS_EDIT:
            const updatedData = state.date.map(item =>
                item.ref === action.payload.ref ? action.payload : item
            );
            return {
                ...state,
                date: updatedData,
                loading: false
            };
        case BANNERS_REMOVE:
            const filteredData = state.date.filter(item => item.ref !== action.payload.ref);
            return {
                ...state,
                date: filteredData,
                loading: false
            };
        case BANNERS_ERROR:
            return {
                ...state,
                loading: false,
                error: {
                    flag: true,
                    msg: action.payload
                }
            };
        default:
            return state;
    }
};
